module.exports = __webpack_public_path__ + "images/store_case_study/sbkart-pic1_b3774f621a6cc4952a8420948cf20dc5.png";